import { render } from "./EligibilityHomeHealth.vue?vue&type=template&id=a606d852&ts=true"
import script from "./EligibilityHomeHealth.vue?vue&type=script&lang=ts"
export * from "./EligibilityHomeHealth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__